module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof47"
    }
  }, [_c('h2', {
    staticClass: "head"
  }, [_vm._v("Major Russian Military Orders"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent164",
      "id": "theft164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unlike European orders with their century-old traditions, Russian Imperial decorations were established in the early 18th century. Peter the Great adopted European style awards and ceremonies during his reforms. Over the next century, his successors established more orders. Emperor Paul I then organized them into a hierarchy of orders in a unified chapter ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kapitul")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Order of St. Andrew the First-Called")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Orden Sv. Andreia Pervosvannogo")]), _vm._v(") was established by Peter the Great in 1698. Named after Apostle Andrew, it became the highest order of the Russian Empire. To be considered, candidates had to be either a prince or count, hold the position of senator, minister, or ambassador, and have the military rank of general or admiral. In some cases, governor generals of the provinces were eligible for the order after 10 years of service. The order could not be awarded to disabled persons or noblemen younger than 25. Peter the Great awarded 40 of these orders during his reign. Another 231 men were honored between 1725 and 1796. In April 1797, Emperor Paul specified the cloth color and type and how the nominee must wear the order. He also allowed male members of the Imperial family to receive the Order of St. Andrew the First-Called upon birth. The rank of Commander of the Order was conferred to 12 recipients based on when they received the award. Three senior Commanders received 1,000 serfs each, four received 800 each, and the final five received 700 each. Upon the Commander’s death, these serfs were transferred to the next recipient. During the Napoleonic Wars, Emperor Alexander bestowed this order on Emperor Napoleon, King Jerome of Westphalia, Prince Charles Talleyrand, and Marshals Alexander Berthier and Joachim Murat at Tilsit in 1807. Eight years later, Arthur Wellesley, Duke of Wellington, was also honored with the Order of St. Andrew the First-Called.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5923c3d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof47.vue
// module id = 234
// module chunks = 0